










































































































































































































































































































import { Mixins, Component } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';
import * as U from '@/utils';

import exceljs from 'exceljs';
import AxAPI from '@/api';
import moment from 'moment';

type Group = I.AxZone;

type PageInfo = I.AttendSearchPageInfo;

type CardList = {};
type CashList = {};

type DataItem = U.DataItem<CardList | CashList, State>;

type DataStore = U.DataStore<CardList>;

type UpdateItemParam = I.PacketMealTimeUpdate;

const DataStore = U.DataStore;

class State {
  listCompanyCode: I.CodeData[];
  listDeptCodeB: I.CodeData[];
  listDutyCodeA: I.CodeData[];
  listUserType: I.CodeData[];

  beginDate: string;
  beginDateMenu: boolean;
  endDate: string;
  endDateMenu: boolean;

  constructor() {
    this.listCompanyCode = [];
    this.listDeptCodeB = [];
    this.listDutyCodeA = [];
    this.listUserType = [];

    this.beginDate = new Date('2016-01-01').toISOString().substr(0, 10);
    this.beginDateMenu = false;
    this.endDate = U.formatTime(new Date().toISOString(), 'YYYY-MM-DD');
    this.endDateMenu = false;
  }
}

class DialogState {
  show: boolean;
  title: string;
  search: string;
  searchSelect: boolean;
  selected: unknown[];
  headers: unknown[];
  items: unknown[];
  callback: () => Promise<void>;

  constructor() {
    this.show = false;
    this.title = '';
    this.search = '';
    this.searchSelect = false;
    this.selected = [];
    this.headers = [];
    this.items = [];
    this.callback = async () => {};
  }
}

abstract class BaseClass extends Mixins(AxPage) {
  API!: AxAPI;
  pageInfo!: PageInfo;
  dataItem!: DataItem;
  dialogState!: DialogState;
}

interface BaseInterface extends BaseClass {}

@Component
class ApiHandler extends BaseClass {
  async getPageInfo() {
    const result = await this.API.call.attend.get();
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async searchAttend(packet: I.PacketAttendanceSearch) {
    this.setLoading(true);
    const result = await this.API.call.attend.attendSearch(packet);
    this.setLoading(false);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async searchCash(packet: I.PacketMealCashSearch) {
    this.setLoading(true);
    const result = await this.API.call.meal.mealCashSearch(packet);
    this.setLoading(false);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }
}

@Component
class DataItemHandler extends BaseClass {
  dataItems: DataItem[] = [
    {
      name: '카드',
      store: new DataStore<CardList>({
        headers: {
          num: { text: '순번', sortable: false },
          eventDate: '날짜',
          name: '이름',
          empNo: '사원번호',
          dept: '부서',
          timeMin: '출근시간',
          timeMax: '퇴근시간',
          timeDuring: '근무시간'
        }
      }),
      search: '',
      description: [],
      state: new State()
    },
    {
      name: '현금',
      store: new DataStore<CashList>({
        headers: {
          num: { text: '순번', sortable: false },
          date: '날짜',
          doorName: '리더기',
          mealName: '식수유형',
          mealcnt: '수량',
          mealprice: '가격',
          timestamp: '저장시간'
        }
      }),
      search: '',
      description: [],
      state: new State()
    }
  ];

  get dataItem() {
    return this.dataItems[0];
  }
}

@Component
class DialogHandler extends BaseClass {
  showCompanySelectDialog() {
    if (!this.pageInfo) return;

    this.showCodeSelectDialog({
      title: '회사 선택',
      param: {
        items: this.pageInfo.listCompanyCode,
        selected: this.dataItem.state.listCompanyCode,
        callback: async (selected: I.CodeData[]) => {
          if (selected.length) {
            this.dataItem.state.listCompanyCode = selected;
          } else {
            this.dataItem.state.listCompanyCode = [];
          }
        }
      }
    });
  }

  showDeptCodeBSelectDialog() {
    if (!this.pageInfo) return;

    this.showCodeSelectDialog({
      title: '부서 선택',
      param: {
        items: this.pageInfo.listDeptCodeB,
        selected: this.dataItem.state.listDeptCodeB,
        callback: async (selected: I.CodeData[]) => {
          if (selected.length) {
            this.dataItem.state.listDeptCodeB = selected;
          } else {
            this.dataItem.state.listDeptCodeB = [];
          }
        }
      }
    });
  }

  showDutyCodeASelectDialog() {
    if (!this.pageInfo) return;

    this.showCodeSelectDialog({
      title: '직급 선택',
      param: {
        items: this.pageInfo.listDutyCodeA,
        selected: this.dataItem.state.listDutyCodeA,
        callback: async (selected: I.CodeData[]) => {
          if (selected.length) {
            this.dataItem.state.listDutyCodeA = selected;
          } else {
            this.dataItem.state.listDutyCodeA = [];
          }
        }
      }
    });
  }

  showUserTypeSelectDialog() {
    this.showCodeSelectDialog({
      title: '사용자 유형 선택',
      param: {
        items: this.pageInfo.listUserType,
        selected: this.dataItem.state.listUserType,
        callback: async (selected: I.CodeData[]) => {
          this.dataItem.state.listUserType = selected;
        }
      }
    });
  }
}

@Component
export class DateHandler extends BaseClass {
  beginDate = U.formatTime(new Date().toISOString(), 'YYYY-MM-DD');
  beginDateMenu = false;
  endDate = U.formatTime(new Date().toISOString(), 'YYYY-MM-DD');
  endDateMenu = false;
  beginTime = '00:00';
  beginTimeMenu = false;
  endTime = '23:59';
  endTimeMenu = false;
}

@Component
class ExcelExportHandler extends Mixins(AxPage) {
  dataItem!: DataItem;

  async onExportExcelConfirm(prefix: string) {
    if (!this.dataItem.description.length) {
      await this.showErrorModal('오류', '조회 후 엑셀 다운로드가 가능합니다');
      return;
    }

    const result = await this.showConfirmModal(
      '확인',
      '검색한 데이터들을 엑셀로 내보냅니다<br />계속하시겠습니까?',
      ['네', '아니오']
    );
    if (result === 0) {
      this.setLoading(true);
      setTimeout(() => this.onExportExcel(prefix), 500);
    }
  }

  async onExportExcel(prefix: string) {
    try {
      const colNames = (n: number) => {
        const ordA = 'A'.charCodeAt(0);
        const ordZ = 'Z'.charCodeAt(0);
        const len = ordZ - ordA + 1;

        let s = '';
        while (n >= 0) {
          s = String.fromCharCode((n % len) + ordA) + s;
          n = Math.floor(n / len) - 1;
        }
        return s;
      };

      moment.locale('ko');
      const momentTime = moment(Date.now());
      const outputPrefix = `${prefix.replace(/\s/g, '_')}_${this.dataItem.name.replace(
        /\s/g,
        ''
      )}_`;

      const workbook = new exceljs.Workbook();
      const worksheet = workbook.addWorksheet('sheet', { properties: { defaultColWidth: 10 } });
      const headers = this.dataItem.store.getHeaders();

      // 엑셀 내보내기시 수작업으로 순번 필드를 만드므로 순번 필드를 삭제시킨다
      const headerEntries = Object.entries(headers).filter(x => x[0] !== 'num');
      const headerKeys = headerEntries.map(x => x[0]);
      const headerValues = headerEntries.map(x => x[1]);

      if (!headers) {
        await this.showErrorModal('확인', '올바르지 않은 테이블 구조입니다');
        return;
      }

      // 헤더 작성 (식수 조회 [사원별] 등등..)
      const headerSize = headerKeys.length;
      worksheet.mergeCells(`A1:${colNames(headerSize)}1`);
      worksheet.getCell('A1').value = `${prefix} [${this.dataItem.name}]`;
      worksheet.getCell('A1').font = { family: 4, size: 18, bold: true };
      worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getCell('A1').border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };

      let row = 2;

      // 구역이나 회사 등등은 검색시 만들어둔 description table을 참고한다
      // 검색 당시와 현재 조건이 다를 수 있으므로 이를 보완한 방법
      this.dataItem.description.forEach(x => {
        worksheet.mergeCells(`A${row}:${colNames(headerSize)}${row}`);
        worksheet.getCell(`A${row++}`).value = x;
      });

      // 생성 시간은 검색 시간과 무관하게 현재 시간을 기준으로 삼는다

      worksheet.mergeCells(`A${row}:${colNames(headerSize)}${row}`);
      worksheet.getCell(`A${row++}`).value = `생성시간 : ${momentTime.format('YYYY-MM-DD LT')}`;

      worksheet.insertRow(
        row,
        [
          'No.',
          ...headerValues.map(x => {
            if (typeof x === 'string') return x;
            else {
              const y = (x as unknown) as { [key: string]: unknown };
              if (y.text) {
                return y.text;
              } else {
                return y;
              }
            }
          })
        ],
        'i'
      );
      const headerRow = row++;
      // 테두리 넣기
      worksheet.getRow(headerRow).eachCell(cell => {
        cell.style = {};
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });

      // 아이템 필터. Header에 들어간 item만 뽑는다
      this.dataItem.store.getItems().forEach((x, idx) => {
        const arr: unknown[] = [idx + 1];
        headerKeys.forEach(y => {
          if (y === 'eventTime') {
            arr.push(this.formatTime(((x as unknown) as { [key: string]: string })[y]));
          } else {
            arr.push(((x as unknown) as { [key: string]: unknown })[y]);
          }
        });
        worksheet.insertRow(row++, arr, 'i');
      });

      // 헤더 라인에 음영 넣기
      worksheet.getRow(headerRow).eachCell(cell => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFBFBFBF' },
          bgColor: { argb: 'FFFFFF00' }
        };

        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };

        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });

      // 엑셀 파일을 저장한다
      const xls64 = await workbook.xlsx.writeBuffer();
      const a = document.createElement('a');
      const data = new Blob([xls64], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const url = URL.createObjectURL(data);
      a.href = url;
      a.download = outputPrefix + momentTime.format('YYYY_MM_DD_HH_mm_ss') + '.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout(function() {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
    } catch (e) {
      await this.showErrorModal('엑셀 내보내기 오류', e.message);
    }
    this.setLoading(false);
  }
}

@Component
class BaseData extends Mixins(AxPage) implements BaseInterface {
  dataItem!: DataItem;

  dialogState = new DialogState();

  pageInfo = {} as PageInfo;
  zoneCode = 0;

  revertZone = false;
  dates = [];

  dialog = false;
}

// vue-class-component의 mixins는 생성자가 5개 이상 넘어가면 unknown으로 캐스팅됨
// 이를 방지하기 위해서 여러 클래스를 분할하는 Mixin 패턴을 사용하려면
// 클래스를 5개씩 끊어서 넣어줘야 한다
const Handlers = Mixins(
  Mixins(ApiHandler, DataItemHandler, DateHandler, DialogHandler),
  Mixins(ExcelExportHandler)
);

@Component
export default class OthersLog extends Mixins(BaseData, Handlers) {
  async prepare() {
    const pageInfo = await this.getPageInfo();
    console.log('page', pageInfo);
    if (pageInfo) {
      this.pageInfo = pageInfo;
      this.zoneCode = this.getZoneList()[0]?.code || 0;
    }
  }

  async onSearchEvent() {
    const result = await this.onAttendanceSearchEvent();
    if (!result) return;

    // this.dataItem.store.setItems(result);
  }

  dates = [];

  makeAttendPacket(): I.PacketAttendanceSearch {
    return {
      dateFrom: `${this.beginDate}T${this.beginTime}:00.000Z`,
      dateTo: `${this.endDate}T${this.endTime}:00.000Z`,
      searchTimeFrom: '0000',
      searchTimeTo: '2359',
      hourFrom: '',
      minuteFrom: '',
      hourTo: '',
      minuteTo: '',
      listCompanyCode: this.dataItem.state.listCompanyCode,
      listDeptCodeB: this.dataItem.state.listDeptCodeB,
      listDutyCode: this.dataItem.state.listDutyCodeA,
      listUserType: this.dataItem.state.listUserType
    };
  }

  async onAttendanceSearchEvent() {
    this.setLoading(true);
    const result = await this.searchAttend(this.makeAttendPacket());
    this.setLoading(false);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result;
    }
  }

  async onSearchClicked() {
    const result = await this.onAttendanceSearchEvent();
    if (!result) return;

    this.dataItem.store.setItems(result);
  }

  async onClearClicked() {
    const result = await this.showConfirmModal('확인', '검색 조건을 초기화할까요?', [
      '네',
      '아니오'
    ]);
    if (result === 0) {
      console.log('attend', this.dataItem.state);
      this.dataItem.state = new State();
    }
  }
}
